import { Utils } from "./Utils";

export class DateTimeHelper {
  static getOneYearAgo = () => {
    const date = new Date();
    date.setDate(date.getDate() - 365);
    return date.toISOString().split("T")[0];
  };

  static getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  static ToLocalString(dateTimeString: string | number | Date | undefined | null) {
    if (Utils.isEmpty(dateTimeString)) {
      return "";
    }

    return new Date(dateTimeString!).toLocaleString();
  }

  static LocalToUTCString(dateTimeString: string | number | Date) {
    return new Date(dateTimeString).toISOString();
  }

  static LocalToStartUTCString(dateTimeString: string) {
    return new Date(dateTimeString + "T00:00:00").toISOString();
  }

  static LocalToEndUTCString(dateTimeString: string) {
    return new Date(dateTimeString + "T23:59:59.999").toISOString();
  }

  static isOlderThanByHours(dateTime: string | number | Date, hours: number): boolean {
    return new Date(dateTime).getTime() < Date.now() - hours * 60 * 60 * 1000;
  }
}
